import { Button } from '@mui/material';

const style = {
  color: '#84d8c5',
  border: '1px solid #84d8c5',
  '&:hover': {
    color: '#FFF',
    border: '1px solid #84d8c5',
    bgcolor: 'rgb(132, 216, 197, 0.2) !important',
  },
  '&:hover .MuiSvgIcon-root': {
    fill: '#FFF !important',
  },
};

export const OutlinedButton = (props) => {
  return (
    <Button
      onClick={props.onClick}
      size="medium"
      sx={{ ...style, ...props.style }}
      variant="outlined"
      fullWidth={props.fullWidth}
      endIcon={props.endIcon}
      href={props.href}
      target={props.target}
    >
      {props.btnTitle}
    </Button>
  );
};
